import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json'
import translationPL from './locales/pl/translation.json'
import translationCS from './locales/cs/translation.json'
import translationUA from './locales/ua/translation.json'
import translationIT from './locales/it/translation.json'
import translationRU from './locales/ru/translation.json'

const fallbackLng = ['en'];
const availableLanguages = ['en', 'pl', 'cs', 'ua', 'it', 'ru'];

i18n
    .use(initReactI18next) // pass the i18n instance to react-i18next.
    .init({

        fallbackLng, // fallback language is english.
        detection: {
            checkWhitelist: true, // options for language detection
        },
        resources: {
            'en': {translation: translationEN},
            'pl': {translation: translationPL},
            'cs': {translation: translationCS},
            'ua': {translation: translationUA},
            'it': {translation: translationIT},
            'ru': {translation: translationRU},
          },
        ns: ['translation'],
        defaultNS: 'translation',
        partialBundledLanguages: "true",

        debug: false,
        supportedLngs: availableLanguages,
        lng: 'en',
        interpolation: {
            escapeValue: false, // no need for react. it escapes by default
        }
    });

export default i18n;